// extracted by mini-css-extract-plugin
module.exports = {"main":"Navbar_main__2wWVS","nav__link":"Navbar_nav__link__2gc0g"};